// src/hooks/useBrandInjector.js
// #Revised UI_v2 — CE1/CE2: inject brand colours and typography as CSS custom properties
import { useEffect } from 'react';

const FONT_SIZE_MAP = {
  small:  '14px',
  medium: '16px',
  large:  '18px',
};

// Track injected font links to avoid duplicates
const LOADED_FONTS = new Set();

function injectGoogleFont(fontFamily) {
  if (!fontFamily || LOADED_FONTS.has(fontFamily)) return;
  const formatted = fontFamily.replace(/ /g, '+');
  const id = `gfont-${formatted}`;
  if (document.getElementById(id)) {
    LOADED_FONTS.add(fontFamily);
    return;
  }
  const link = document.createElement('link');
  link.id   = id;
  link.rel  = 'stylesheet';
  link.href = `https://fonts.googleapis.com/css2?family=${formatted}:wght@400;500;600;700&display=swap`;
  document.head.appendChild(link);
  LOADED_FONTS.add(fontFamily);
}

export function useBrandInjector(salonConfig) {
  useEffect(() => {
    if (!salonConfig) return;
    const root = document.documentElement;

    // #Revised UI_v2 — CE1: brand colour variables
    const colors = salonConfig?.branding?.colors || {};
    root.style.setProperty('--brand-primary',    colors.primary    || '#b6a593');
    root.style.setProperty('--brand-secondary',  colors.secondary  || '#a69483');
    root.style.setProperty('--brand-accent',     colors.accent     || '#d9c5b2');
    root.style.setProperty('--brand-background', colors.background || '#fdf8f5');
    root.style.setProperty('--brand-text',       colors.text       || '#6b5b4d');

    // #Revised UI_v2 — CE2: typography variables
    const typo = salonConfig?.branding?.typography || salonConfig?.typography || {};
    const headingFont = typo.headingFont || 'Playfair Display';
    const bodyFont    = typo.bodyFont    || 'Lato';
    const fontSize    = FONT_SIZE_MAP[typo.fontSize] || '16px';

    root.style.setProperty('--brand-heading-font', `'${headingFont}', serif`);
    root.style.setProperty('--brand-body-font',    `'${bodyFont}', sans-serif`);
    root.style.setProperty('--brand-font-size',    fontSize);

    // Inject Google Font stylesheet links dynamically
    injectGoogleFont(headingFont);
    injectGoogleFont(bodyFont);
  }, [salonConfig]);
}
